'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { ArrowIcon } from '@insta-club/components';
import { useCustomForm } from '@insta-club/hooks';
import { BottomSheet, Button, Form, Input } from '@insta-club/ui';
import { detectUsernameTypeDetailed } from '@insta-club/utilities';
import { SignInFormValues, SignInSchema } from '@insta-club/validator';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';

function SignInForm() {
    const router = useRouter();
    const form = useCustomForm(SignInSchema, { username: '' });
    const [isSignupSheetOpen, setIsSignupSheetOpen] = useState<boolean>(false);

    const onSubmit: SubmitHandler<SignInFormValues> = async (data) => {
        try {
            const { username } = data;
            const res: { exist: boolean; ttl: number } = await fetcher(ApiKeys.SIGN_IN, 'web', 'POST', {
                body: {
                    username
                }
            });

            if (res?.exist) {
                // router.push(`/auth/otp?exist=${res?.exist}&username=${username}&method=login`);
                router.push(`/auth/password?username=${username}`);
            } else {
                setIsSignupSheetOpen(true);
            }

            // await fetcher(ApiKeys.SEND_VERIFICATION_CODE, 'web', 'POST', {
            //     body: {
            //         username
            //     }
            // });
        } catch (error) {
            console.log(error);
        }
    };

    const handleSignUp = (username: string): void => {
        router.push(`/auth/otp?exist=false&username=${username}&method=register`);
        setIsSignupSheetOpen(false);
    };

    return (
        <>
            <Form form={form} onSubmit={onSubmit}>
                <Input name='username' inputType='english' label='شماره همراه یا ایمیل' />
                <p className='my-6 text-sm font-medium text-gray-400'>
                    ثبت نام در اینستا کلاب به معنای پذیرش{' '}
                    <Link prefetch={false} href={'/terms'} className='text-primary-500'>
                        شرایط استفاده
                    </Link>{' '}
                    و{' '}
                    <Link prefetch={false} href={'/privacy'} className='text-primary-500'>
                        قوانین حریم خصوصی
                    </Link>{' '}
                    است.
                </p>
                <Button
                    fullWidth
                    type='submit'
                    size='lg'
                    loading={form.formState.isSubmitting}
                    icon={<ArrowIcon className='rotate-180 text-white' />}
                    iconPosition='end'
                >
                    <span className='text-base font-semibold'>مرحله بعد</span>
                </Button>
            </Form>
            <BottomSheet open={isSignupSheetOpen} onClose={() => setIsSignupSheetOpen(false)}>
                <div className='text-center'>
                    <h4 className='mb-3 text-2xl font-semibold text-gray-900'>ایجاد حساب جدید</h4>
                    <p className='mx-auto mb-11 max-w-[350px] text-sm font-medium text-gray-900'>
                        با {detectUsernameTypeDetailed(form.getValues('username') ?? '').label}{' '}
                        {form.getValues('username')} حساب کاربری در اینستا کلاب وجود ندارد، مایل به ثبت نام هستید ؟
                    </p>
                    <div className='space-y-2'>
                        <Button
                            fullWidth
                            className='py-3.5! font-semibold!'
                            onClick={() => handleSignUp(form.getValues('username'))}
                        >
                            بله، ثبت نام میکنم
                        </Button>
                        <Button
                            variant='text'
                            fullWidth
                            className='py-3.5! font-semibold! text-gray-900!'
                            onClick={() => setIsSignupSheetOpen(false)}
                        >
                            انصراف
                        </Button>
                    </div>
                </div>
            </BottomSheet>
        </>
    );
}

export default SignInForm;

